import React, { useState, useMemo } from "react"
import DefaultAvatar from "../../../../assets/img/user-placeholder.svg"
import CustomDataTable from "../../shared/CustomDataTable"

const PAGE_SIZE = 10

const getEmployeeName = (employee) => {
  if (employee.first_name) {
    return `${employee.first_name} ${employee.last_name || ''}`.trim()
  }
  return employee.email || '-'
}

const columns = [
  {
    key: 'name',
    label: 'Nome',
    sortKey: 'name',
  },
]

const sortEmployees = (data, sort) => {
  if (!sort.key) return data
  return [...data].sort((a, b) => {
    const nameA = getEmployeeName(a).toLowerCase()
    const nameB = getEmployeeName(b).toLowerCase()
    return sort.direction === 'asc'
      ? nameA.localeCompare(nameB)
      : nameB.localeCompare(nameA)
  })
}

const renderRow = (employee, index, className) => {
  const name = getEmployeeName(employee)
  const avatarUrl = employee.avatar && employee.avatar.url
    ? employee.avatar.url
    : DefaultAvatar

  return (
    <tr key={employee.id} className={`data-table__row ${className}__row`}>
      <td className={`data-table__cell ${className}__cell ${className}__cell--name`}>
        <div className="analytics-player-row">
          <img
            alt=""
            src={avatarUrl}
            className="analytics-player-row__avatar"
          />
          <span className="analytics-player-row__name">{name}</span>
        </div>
      </td>
    </tr>
  )
}

const Contributors = ({ group }) => {
  const [page, setPage] = useState(1)
  const [sort, setSort] = useState({ key: 'name', direction: 'asc' })
  const employees = group.employees || []

  // Sort full dataset, then paginate
  const sortedEmployees = useMemo(
    () => sortEmployees(employees, sort),
    [employees, sort]
  )

  const totalPages = Math.ceil(sortedEmployees.length / PAGE_SIZE)
  const start = (page - 1) * PAGE_SIZE
  const pageData = sortedEmployees.slice(start, start + PAGE_SIZE)

  const handlePageChange = (data) => {
    setPage(data.selected + 1)
  }

  const handleSort = (newSort) => {
    setSort(newSort)
    setPage(1)
  }

  return (
    <div className="analytics-layout-content">
      <CustomDataTable
        className="contributors-table"
        columns={columns}
        data={pageData}
        renderRow={renderRow}
        rowKey={(item) => item.id}
        defaultSort={sort}
        onSort={handleSort}
        pagination={{
          totalPages: totalPages,
          currentPage: page,
          onPageChange: handlePageChange,
        }}
        emptyMessage="Sem jogadores"
      />
    </div>
  )
}

export default Contributors
